import * as i18next from 'i18next';
var instance = i18next.createInstance();
export var setupI18n = function (language) { return instance.init(createConfig(language)); };
export var getInstance = function () { return instance; };
var createConfig = function (language) {
    var _a;
    return ({
        lng: language,
        resources: (_a = {},
            _a[language] = {
                translation: require("../locale/messages_en.json"),
            },
            _a),
    });
};
//# sourceMappingURL=i18n.js.map